import * as React from 'react'

function SvgIconMenu3DotsH(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="menu-3-dots-h" aria-labelledby="t-menu-3-dots-h d-menu-3-dots-h">
        <title id="t-menu-3-dots-h">{'Menu 3 dots horizontal'}</title>
        <desc id="d-menu-3-dots-h">{'3 dots in horizontal row'}</desc>
        <circle cx={28} cy={16} r={4} />
        <circle cx={16} cy={16} r={4} />
        <circle cx={4} cy={16} r={4} />
      </g>
    </svg>
  )
}

export default SvgIconMenu3DotsH
